import { FC, useState } from "react"

import './pajera.css'
import { PajeraTable } from "./PajeraTable/PajeraTable";
import { PajeraTableSimple } from "./PajeraTable/PajeraTableSimple";


export const Pajera:FC<any> = (props):JSX.Element => {

    const { data, dataMASTER, setData, setDataMASTER, simulated,original, comparativa, saveLoading, same, scenarioBase,dataPlanificacion } = props
   
    

    const [selectedProvider, setSelectedProvider] = useState<number>(-1)

    

    return (
        <div className="pajera__wrapper">
            <div className="pajera__container">
                {
                    comparativa?
                        <PajeraTable
                            scenarioBase={scenarioBase}
                            data={data}
                            dataMASTER={dataMASTER}
                            setData={setData}
                            setDataMASTER={setDataMASTER}
                            selectedProvider={selectedProvider}
                            setSelectedProvider={setSelectedProvider}
                            simulated={simulated}
                            original={original}
                            comparativa={comparativa}
                            saveLoading={saveLoading}
                            same={same}
                            dataPlanificacion={dataPlanificacion}
                        />
                    :
                        <PajeraTableSimple
                            scenarioBase={scenarioBase}
                            data={data}
                            dataMASTER={dataMASTER}
                            setData={setData}
                            setDataMASTER={setDataMASTER}
                            selectedProvider={selectedProvider}
                            setSelectedProvider={setSelectedProvider}
                            simulated={simulated}
                            original={original}
                            comparativa={comparativa}
                            saveLoading={saveLoading}
                            dataPlanificacion={dataPlanificacion}
                        />
                }
                
            </div>
            
        </div>
    )
}